var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 4L0 18L8 21.6V28.4C5.6 29.2 4 31.6 4 34C4 36.4 5.6 38.8 8 39.6V40L4.4 48.4C3.2 52 4 56 10 56C16 56 16.8 52 15.6 48.4L12 40C14.4 38.8 16 36.8 16 34C16 31.2 14.4 29.2 12 28.4V23.6L30 32L60 18L30 4ZM47.6 30L29.6 38L20 33.6V34C20 36.8 18.8 39.2 16.8 41.2L19.2 46.8V47.2C19.6 48.8 20 50.4 19.6 52C22.4 53.2 25.6 54 29.6 54C42.8 54 47.6 46 47.6 42V30Z",
    fill: "#690830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.315714f46835609e235ba2b5c4908f93.svg";
export { ForwardRef as ReactComponent };